import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MyTeamBackoffice from './MyTeamBackoffice';
import { getUserSettings, init } from './myTeamBackOffice.actions';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';

const MyTeamBackofficeRoot = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(init());
    dispatch(getUserSettings());
  }, [dispatch]);

  return (
    <AnimatedDashboard zoom>
      <MyTeamBackoffice />
    </AnimatedDashboard>
  );
};

export default MyTeamBackofficeRoot;
